const userInfo = {
    state: {
        accessToken: null
    },
    mutations: {
        setAccessToken: (state,accessToken) => {
            state.accessToken = accessToken;
        }
    }
}

export default userInfo;


// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js